import loadMoreButton from '~/js/lib/collection'; // eslint-disable-line

export default (node) => {
  const filterDrawer = document.querySelector('[data-filter-drawer]');
  const contentLoading = document.querySelector(
    '[data-filter-content-loading]'
  );
  let overlay = null;

  const openFilterMenu = () => {
    filterDrawer.classList.remove('opacity-0');
    filterDrawer.classList.add('!translate-x-0');
    overlay.classList.remove('hidden');
  };

  const closeFilterMenu = () => {
    filterDrawer.classList.add('opacity-0');
    filterDrawer.classList.remove('!translate-x-0');
    overlay.classList.add('hidden');
  };

  // apply filters and close the menu
  const applyAndClose = async () => {
    // take the current Url
    let currentUrl = window.location.pathname + window.location.search;

    await processCollectionWithFilters(currentUrl);
  };

  // apply the filters to the collection
  const applyFilters = (e) => {
    let element = null;
    if (e.detail) {
      element = e.detail.button;
    } else {
      element = e.currentTarget;
    }

    const urlToAdd = element.dataset.filterUrlToAdd;
    const urlToRemove = element.dataset.filterUrlToRemove;
    const isChecked = element.checked;
    let urlToCall = isChecked ? urlToAdd : urlToRemove;

    processCollectionWithFilters(urlToCall);
    window.history.pushState({}, '', urlToCall);
  };

  const processCollectionWithFilters = (urlToCall) => {
    contentLoading.classList.remove('hidden');
    const collectionProducts = document.querySelector('[data-collection-grid]');

    loadMoreButton(urlToCall).then((products) => {
      // get the products from the response
      const resultsMarkup = products.querySelector(
        '[data-collection-grid]'
      ).innerHTML;
      // append the products to the current collection
      if (collectionProducts) {
        collectionProducts.innerHTML = resultsMarkup;
      }

      // update filter footer
      const filterFooter = products.querySelector('[data-filter-footer]');
      if (filterFooter) {
        const currentFilterFooter = document.querySelector(
          '[data-filter-footer]'
        );
        currentFilterFooter.innerHTML = filterFooter.innerHTML;
      }

      // update results count
      const resultsCount = products.querySelector('[data-collection-count]');
      if (resultsCount) {
        const currentResultsCount = document.querySelector(
          '[data-collection-count]'
        );
        currentResultsCount.innerHTML = resultsCount.innerHTML;
      }

      // update the filters
      const currentFilterContainer = document.querySelector(
        '[data-filter-container]'
      );
      if (currentFilterContainer) {
        currentFilterContainer.innerHTML = products.querySelector(
          '[data-filter-container]'
        ).innerHTML;
        document.dispatchEvent(
          new CustomEvent('shopify:section:load:accordion', {
            detail: {
              node: currentFilterContainer,
            },
          })
        );
      }

      // update the filters applied
      const currentFiltersApplied = document.querySelector(
        '[data-collection-filters-applied]'
      );
      if (currentFiltersApplied) {
        currentFiltersApplied.innerHTML = products.querySelector(
          '[data-collection-filters-applied]'
        ).innerHTML;
      }

      // update the product cards
      const productCards = collectionProducts.querySelectorAll(
        '[data-product-card]'
      );
      productCards.forEach((productCard) => {
        document.dispatchEvent(
          new CustomEvent('shopify:section:load:product-cards', {
            detail: {
              node: productCard,
            },
          })
        );
      });

      const allPriceRange = document.querySelectorAll(
        '[data-component="priceRange"]'
      );
      allPriceRange.forEach((priceRange) => {
        document.dispatchEvent(
          new CustomEvent('shopify:section:load:price-range', {
            detail: {
              node: priceRange,
            },
          })
        );
      });

      // update the sort options
      const sortWrapper = document.querySelector('[data-sort-wrapper]');
      if (sortWrapper) {
        const currentSortWrapper = products.querySelector(
          '[data-sort-wrapper]'
        );
        sortWrapper.innerHTML = currentSortWrapper.innerHTML;
      }

      document.dispatchEvent(
        new CustomEvent('collection-filter:add-listeners')
      );

      init();
      contentLoading.classList.add('hidden');
    });
  };

  const showButtons = () => {
    const filterFooter = document.querySelector('[data-filter-footer] > div');
    filterFooter.classList.remove('hidden');
  };

  const applySort = (e) => {
    // e.preventDefault();
    const sortValue = e.target.dataset.sortOption;
    // check if the url has sort_by parameter, if exits replace it with the new value else add it
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    searchParams.set('sort_by', sortValue);
    // modify the url with the new search params without reloading the page
    const urlToCall = `${url.origin}${url.pathname}?${searchParams.toString()}`;
    window.history.pushState({}, '', urlToCall);

    processCollectionWithFilters(urlToCall);
  };

  // switch between product and lifestyle images
  const handleSwitch = (e) => {
    const switchTo = e.currentTarget.dataset.collectionSwitch;

    const allProducts = node.querySelectorAll('[data-product-card]');

    allProducts.forEach((product) => {
      const productImage = product.querySelector('[data-image-index="0"]');
      let styleImage = product.querySelector('[data-image-style]');

      if (styleImage) {
        styleImage = styleImage.getAttribute('data-image-style');

        const originalImage = product
          .querySelector('[data-first-image]')
          .getAttribute('data-first-image');

        productImage.innerHTML =
          switchTo === 'product' ? originalImage : styleImage;
      }
    });

    const collectionSwitches = document.querySelectorAll(
      '[data-collection-switches] > button'
    );
    collectionSwitches.forEach((button) => {
      if (button.dataset.collectionSwitch === switchTo) {
        button.classList.add(
          'text-gray-90',
          '!border-gray-20',
          'hover:!bg-gray-10',
          '!bg-gray-10'
        );
        button.classList.remove('text-gray-70');
      } else {
        button.classList.remove(
          'text-gray-90',
          '!border-gray-20',
          'hover:!bg-gray-10',
          '!bg-gray-10'
        );
        button.classList.add('text-gray-70');
      }
    });
  };

  const init = () => {
    const sortButton = node.querySelector('[data-sort-button]');

    sortButton.addEventListener('click', (e) => {
      e.preventDefault();
      const sortMenu = node.querySelector('[data-sort-options]');
      sortMenu.classList.toggle('hidden');
    });

    const sortOptions = node.querySelectorAll('[data-sort-option]');
    sortOptions.forEach((option) => {
      option.addEventListener('click', applySort);
    });

    const filterButton = node.querySelector('[data-filter-button]');
    filterButton.addEventListener('click', openFilterMenu);

    overlay = document.querySelector('[data-filter-overlay]');
    overlay.addEventListener('click', closeFilterMenu);

    const closeButton = document.querySelector('[data-filter-close]');
    closeButton.addEventListener('click', closeFilterMenu);

    const filtersOptions = document.querySelectorAll('[data-apply-filter]');
    filtersOptions.forEach((option) => {
      option.addEventListener('change', applyFilters);
    });

    const filterDone = document.querySelector('[data-filter-done]');
    if (filterDone) {
      filterDone.addEventListener('click', applyAndClose);
    }

    document.addEventListener('collection-filter:show-buttons', showButtons);

    // if click outside of the sort menu, close it
    document.addEventListener('click', (e) => {
      const sortMenu = node.querySelector('[data-sort-options]');
      if (
        !Object.keys(e.target.dataset).includes('sortOptions') &&
        !Object.keys(e.target.dataset).includes('sortOptionItem') &&
        !Object.keys(e.target.dataset).includes('sortButton') &&
        !Object.keys(e.target.dataset).includes('sortButtonIcon')
      ) {
        sortMenu.classList.add('hidden');
      }
    });

    const collectionSwitches = document.querySelectorAll(
      '[data-collection-switches] > button'
    );
    collectionSwitches.forEach((button) => {
      button.addEventListener('click', handleSwitch);
    });
  };

  init();
};
